import React from 'react'
import PropTypes from 'prop-types'
import { CategoriesRenderer } from 'LiveBoard/components/shared/CategoriesRenderer'
import { Skeleton } from './Skeleton'
import { CATEGORY_TYPES } from 'LiveBoard/config/constants'
import isEmpty from 'lodash/isEmpty'
import get from 'lodash/get'
import { ACCESSIBILITY_CLASSES } from 'shared/helpers/AccessibilityHelper'

import './style.css.scss'

const Categories = (props) => {
  const {
    categories, categoryIds, categoryTheme, themeColorHex, board,
    onCategoryClick, selectedCategoryId, showHomeCategory, showSearch
  } = props

  const selectedCategory = categories[selectedCategoryId]
  return (
    !isEmpty(categoryIds) && (

      <section className={`categories-container ${categoryTheme} ${showSearch ? 'show-search' : ''} ${ACCESSIBILITY_CLASSES.main}`}>
        { isEmpty(categories) ? (
            <Skeleton categoriesCount={3} />
          ) : (
          <CategoriesRenderer
            board={board}
            categories={categories}
            categoryIds={categoryIds}
            categoryTheme={categoryTheme}
            themeColorHex={themeColorHex}
            selectedCategoryId={selectedCategoryId}
            showHomeCategory={showHomeCategory}
            onSelect={onCategoryClick}
            autoClose={true} />
        )}
        { get(selectedCategory, 'category_type') == CATEGORY_TYPES.subcategory && (
          <h1 className="selected-subcategory" style={{color: themeColorHex}}>
            {selectedCategory.name}
          </h1>
        )}
      </section>
    )
  )
}

Categories.propTypes = {
  themeColorHex: PropTypes.string.isRequired,
  selectedCategoryId: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  board: PropTypes.object.isRequired,
  categories: PropTypes.object,
  categoryIds: PropTypes.array,
  onCategoryClick: PropTypes.func.isRequired,
  showHomeCategory: PropTypes.bool
}

export default Categories
